import { gql } from '@apollo/client';
import { NEW_CAMPAIGN } from '../fragments/campaign';
import { NEW_ORDER } from '../fragments/orders';

// CREATE_NEW_CAMPAIGN, UPDATE_CAMPAIGN, UPDATE_CAMPAIGN_RELATIONSHIPS eliminados
// (Bloque C-Limpieza 2026-05-08): sustituidos por SAVE_CAMPAIGN atómica.

/**
 * Endpoint unificado que reemplaza CREATE_NEW_ORDER + CREATE_NEW_CAMPAIGN +
 * UPDATE_ORDER + UPDATE_CAMPAIGN + UPDATE_CAMPAIGN_RELATIONSHIPS +
 * UPDATE_ORDER_RELATIONSHIPS del flujo NewCampaign/EditCampaign.
 * Ver PLAN-SAVE-ENTITY-UNIFIED.md §2.4.
 */
export const SAVE_CAMPAIGN = gql`
  mutation SaveCampaign($input: SaveCampaignInput!) {
    saveCampaign(input: $input) {
      order {
        ...NewOrder
      }
      campaign {
        ...NewCampaign
      }
    }
  }
  ${NEW_ORDER}
  ${NEW_CAMPAIGN}
`;
